module.exports = __webpack_public_path__ + "73018b936823e9bffd68b0586f70e14c.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/image-border.png
// module id = 389
// module chunks = 0